import classNames from 'classnames';
import * as React from 'react';
import withPlaybackContext from '../../common/withPlaybackContext';
import { KeyboardKey } from '../../types';
import SkipIcon from './assets/skip';
import { classes } from './Skip.st.css';
var Skip = function (props) {
    var _a;
    return (React.createElement("button", { className: classNames(classes.button, (_a = {}, _a[classes.disabled] = props.disabled, _a), props.className), "data-hook": props.dataHook, "aria-label": props.back ? 'Play previous' : 'Play next', type: "button", onClick: props.back ? props.context.previous : props.context.next, onKeyDown: function (e) {
            if (e.key === KeyboardKey.Space) {
                return;
            }
            props.context.handleKeyDown(e);
        }, disabled: props.disabled },
        React.createElement("div", { className: classes.iconWrapper + " " + (props.back ? classes.backSkip : '') }, props.iconSkip)));
};
Skip.displayName = 'Skip';
Skip.defaultProps = {
    className: '',
    dataHook: '',
    iconSkip: React.createElement(SkipIcon, null),
    back: false,
    disabled: false,
};
export default withPlaybackContext(Skip);
//# sourceMappingURL=Skip.js.map